import {ReactElement} from 'react';

import * as styles from './review-preview-video.scss';

type PropsType = {
    src: string;
};

export function ReviewPreviewVideoStreamEmbed(props: PropsType): ReactElement {
    const {src} = props;

    return (
        // eslint-disable-next-line react/iframe-missing-sandbox -- third-party embed player page
        <iframe
            allow="autoplay; encrypted-media; fullscreen; picture-in-picture"
            allowFullScreen
            className={styles.ReviewPreviewVideo_embed}
            src={src}
            title="Video player"
        />
    );
}
